import * as React from "react";
import Modal from "@mui/material/Modal";
import "./style.scss";

const style = {
  bgcolor: "background.paper",
};

export default function TransitionsModal({
  handleClose,
  open,
  classname = "",
  children,
  fullScreenMobile = false,
  ...rest
}) {
  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <div 
          className={`${classname} modal-content payModal ${fullScreenMobile ? "fullScreenMobile" : ""
            }`}
        >
          {children}
        </div>
      </Modal>
    </div>
  );
}
